import { Component, inject, Input, OnInit } from '@angular/core';
import { ScreeningBriefResponseDto, ScreeningListResponseDto } from '../../../../common/general-types/social-screening.dto';
import { SocialScreeningService } from '../../../../services/social-screening/social-screening.service';
import { CreatorReviewItemComponent } from '../creator-review-item/creator-review-item.component';

@Component({
  selector: 'sbr-creators',
  standalone: true,
  imports: [CreatorReviewItemComponent],
  templateUrl: './creators.component.html',
  styleUrl: './creators.component.css'
})
export class CreatorsComponent implements OnInit {

  @Input() focussedScreeningBrief!: ScreeningBriefResponseDto;
  @Input() focussedCreatorList!: ScreeningListResponseDto;

  /** Services */
  private socialScreeningService = inject(SocialScreeningService);
  /** Services - END */

  ngOnInit(): void {
    console.log('******* Creators -> ', this.focussedCreatorList);
  }

  /**
   * The brief's creator list is a recruit group now, so its members are full Creator
   * records. Map them to the compact shape the review item expects.
   */
  get reviewItems(): {
    creatorId?: string;
    id?: string;
    name: string;
    instagramHandle?: string;
    tiktokHandle?: string;
  }[] {
    return (this.focussedCreatorList?.creators ?? []).map((creator) => ({
      creatorId: creator.blazeFirebaseUid,
      id: creator.blazeFirebaseUid,
      name: `${creator.firstName ?? ''} ${creator.lastName ?? ''}`.trim() || 'Creator',
      instagramHandle: creator.instaHandle ?? undefined,
      tiktokHandle: creator.tikTokHandle ?? undefined,
    }));
  }

  

}
